var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcArrowLeftDisabled = function SvgIcArrowLeftDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 16.875H7.2l9.45-9.225-1.8-1.8L2.925 18 14.85 30.15l1.8-1.8-9.45-9.225h24.3v-2.25z",
    fill: "#BDBDBD"
  })));
};
export { SvgIcArrowLeftDisabled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0zMS41IDE2Ljg3NUg3LjJsOS40NS05LjIyNS0xLjgtMS44TDIuOTI1IDE4IDE0Ljg1IDMwLjE1bDEuOC0xLjgtOS40NS05LjIyNWgyNC4zdi0yLjI1eiIgZmlsbD0iI0JEQkRCRCIvPgo8L3N2Zz4K";